module.exports = ".pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/service360/service360.component.css
// module id = 1001
// module chunks = 1